import apiFetch from '../../apiFetch'

export default function (dossierId, orderby, token) {
  orderby = encodeURIComponent(orderby)
  return apiFetch({ endPoint: `dossier/${dossierId}/relatedHistorical?orderby=${orderby}`, method: 'GET', token: token })
}
